/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { installAllPatches } from './monkey';

installAllPatches();

export * from './dialogs';
export * from './form';
export * from './waiting';
export * from './utils';
export * from './common';
export * from './uploader';
export * from './notifications/notification.service';
export * from './toasts';
export * from './table-layout';
export * from './menu';
